export function getChartFontFamily(): string {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return 'Nunito Sans, sans-serif';
  }

  const computedStyle = getComputedStyle(document.body);
  const fontFamily = computedStyle
    .getPropertyValue('--font-family-primary')
    .trim();

  return fontFamily.replace(/['"]/g, '') || 'Nunito Sans, sans-serif';
}

export function getChartFontFamilyWithQuotes(): string {
  const fontFamily = getChartFontFamily();

  if (fontFamily.includes('"') || fontFamily.includes("'")) {
    return fontFamily;
  }

  if (fontFamily.includes(',')) {
    const parts = fontFamily.split(',').map((f) => f.trim());

    return `"${parts[0]}", ${parts.slice(1).join(', ')}`;
  }

  return `"${fontFamily}"`;
}
